import { Correspondence } from './Correspondence';




export class AppointmentCorrespondence {
  constructor(

    public responseArray?: Correspondence[],
    public requestId?: number
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/AppointmentCorrespondence.ts